module.exports = __webpack_public_path__ + "static/media/Maf_QuienesSomos_ICONO.8e103831.png";